module.exports = __webpack_public_path__ + "static/media/logo.3fbb88c6.svg";